<template>
  <div>
    <b-card>
      <div class="text mb-3 pt-1">
        <div class="arabic-name">مستشفى الوزيرية الأهلي</div>
        <div class="english-name">Al-Waziria Private Hospital</div>

        <b-img
          class="mb-2 logo"
          :src="hospitalLogo"
          width="200"
          height="200"
          style="filter: invert(1)"
        />
      </div>
    </b-card>
    <b-card :title="$t('reception.register-patient')">
      <b-row>
        <b-col cols="12">
          <h3 class="text-center my-2">
            {{ $t("reception.personal-info") }}
          </h3>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group
            :label="$t('common.name')"
            label-for="Name"
            class="required"
          >
            <b-form-input
              id="Name"
              v-model="addForm.name"
              :state="errorForm.name ? false : null"
              :placeholder="$t('common.name')"
            />
            <small class="text-danger">{{ errorForm.name }}</small>
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group
            :label="$t('clinic.mother-name')"
            label-for="Name"
            class="required"
          >
            <b-form-input
              id="Name"
              v-model="addForm.mother_name"
              :state="errorForm.mother_name ? false : null"
              :placeholder="$t('clinic.mother-name')"
            />
            <small class="text-danger">{{ errorForm.mother_name }}</small>
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group
            :label="$t('reception.gender')"
            label-for="Gender"
            class="required"
          >
            <v-select
              v-model="addForm.gender"
              :options="genderOption"
              :placeholder="$t('reception.gender')"
            />
            <small class="text-danger">{{ errorForm.gender }}</small>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group
            :label="$t('reception.phone')"
            label-for="phoneNumber"
            class="required"
          >
            <VuePhoneNumberInput
              v-model="addForm.phone"
              default-country-code="IQ"
              :error="
                addForm.phone ? isNotValid || addForm.phone[0] != 0 : false
              "
              @update="
                (obj) => {
                  showPhoneObj(obj, 'countryCallingCode');
                }
              "
            />
            <small class="text-danger">{{ errorForm.phone }}</small>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group :label="$t('common.Occupation')" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.occupation"
              :placeholder="$t('common.Occupation')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.birth-date')"
            class="required"
            label-for="entry_date"
          >
            <datepicker
              v-model="addForm.birth_date"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              :required="errorForm.birth_date ? true : false"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            />
            <small class="text-danger">{{ errorForm.birth_date }}</small>
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            class="required"
            :label="$t('reception.martial-status')"
            label-for="status"
          >
            <v-select
              v-model="addForm.marital_status"
              :options="maritalStatusOptions"
              :placeholder="$t('reception.martial-status')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.educational-level')"
            label-for="status"
          >
            <v-select
              v-model="addForm.education_level"
              :options="educationalLevelOptions"
              :placeholder="$t('reception.educational-level')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.residence-type')"
            label-for="Residence"
          >
            <v-select
              v-model="addForm.residence_type"
              :options="residenceOptions"
              :placeholder="$t('reception.residence-type')"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <AutoComplete
            v-model="addForm.governorate_id"
            class="required"
            :label="$t('reception.governorate')"
            :placeholder="$t('reception.governorate')"
            :serializer="(val) => val.id"
            param-query="search"
            endpoint="governorate"
            text-title="name"
          />
          <small class="text-danger">{{ errorForm.governorate_id }}</small>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group
            :label="$t('reception.judiciary-name')"
            label-for="Judiciary"
          >
            <b-form-input
              id="Governorate"
              v-model="addForm.judiciary_name"
              :placeholder="$t('reception.judiciary-name')"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" cols="12">
          <b-form-group :label="$t('reception.township')" label-for="Township">
            <b-form-input
              id="Township"
              v-model="addForm.town_name"
              :placeholder="$t('reception.township')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <!-- <AutoComplete
            class="required"
            :label="$t('reception.city-name')"
            :placeholder="$t('reception.city-name')"
            v-model="addForm.city_name"
            :serializer="(val) => val.name"
            param-query="search"
            endpoint="city"
            text-title="name"
          /> -->
          <b-form-group
            class="required"
            :label="$t('reception.city-name')"
            label-for="City"
          >
            <b-form-input
              id="City"
              v-model="addForm.city_name"
              :placeholder="$t('reception.city-name')"
            />
          </b-form-group>
          <small class="text-danger">{{ errorForm.city_name }}</small>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.district-name')"
            label-for="district_name"
          >
            <b-form-input
              id="district_name"
              v-model="addForm.district_name"
              type="number"
              :placeholder="$t('reception.district-name')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.street-name')"
            label-for="street_name"
          >
            <b-form-input
              id="street_name"
              v-model="addForm.street_name"
              type="number"
              :placeholder="$t('reception.street-name')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.building-number')"
            label-for="building_number"
          >
            <b-form-input
              id="building_number"
              v-model="addForm.building_number"
              :placeholder="$t('reception.building-number')"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <h3 class="text-center my-2">
            {{ $t("common.documents") }}
          </h3>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.paper-number')"
            label-for="paper_number"
          >
            <b-form-input
              id="paper_number"
              v-model="addForm.document_page_number"
              :placeholder="$t('reception.paper-number')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.document-number')"
            label-for="Document_number"
          >
            <b-form-input
              id="document_number"
              v-model="addForm.document_number"
              :placeholder="$t('reception.document-number')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            :label="$t('reception.dpcs')"
            label-for="Document_number"
          >
            <b-form-input
              id="document_number"
              v-model="addForm.department_of_civil_status"
              :placeholder="$t('reception.dpcs')"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" cols="12">
          <b-form-group
            class="required"
            :label="$t('reception.national-id')"
            label-for="national_id"
          >
            <b-form-input
              id="national_id"
              v-model="addForm.national_id"
              placeholder="Enter National ID"
            />
          </b-form-group>
        </b-col>
        <b-row v-if="!patientId" class=" ">
          <b-col cols="12">
            <h3 class="text-center my-2">
              {{ $t("reception.patient-card-info") }}
            </h3>
          </b-col>
          <b-col md="12" cols="12">
            <b-form-group
              :label="$t('reception.card-type')"
              label-for="Type"
              class="required"
            >
              <v-select
                v-model="addForm.type"
                :options="['IN', 'OUT', 'EMERGENCY', 'CLINIC', 'LAB']"
                :placeholder="$t('reception.card-type')"
              />
              <small class="text-danger">{{ errorForm.type }}</small>
            </b-form-group>
            <b-form-group
              v-if="addForm.type === 'IN'"
              :label="$t('reception.treatment-type')"
              label-for="treatmentType"
              class="required"
            >
              <div class="radio-group">
                <!-- Private Insurance Option -->
                <input
                  type="radio"
                  v-model="treatment_type"
                  name="treatment_type"
                  id="private"
                  value="Bed Rest"
                  class="radio-input"
                  style="position: absolute; opacity: 0"
                />
                <label for="private" class="radio-label w-100">
                  <span class="radio-text">{{ $t("reception.bed-rest") }}</span>
                </label>

                <!-- Government Insurance Option -->
                <input
                  type="radio"
                  v-model="treatment_type"
                  name="treatment_type"
                  id="government"
                  value="Surgery"
                  class="radio-input"
                  style="position: absolute; opacity: 0"
                />
                <label for="government" class="radio-label w-100">
                  <span class="radio-text">{{ $t("reception.surgery") }}</span>
                </label>
              </div>
            </b-form-group>
          </b-col>
          <div
            v-if="addForm.type === 'IN' && treatment_type === 'Bed Rest'"
            class="mt-2 mt-md-0 w-100 mx-1"
          >
            <b-row>
              <b-col md="12" cols="12" class="mt-3">
                <b-form-group label="Doctors">
                  <v-select
                    v-model="selectedDoctors"
                    :options="doctors"
                    multiple
                    label="name"
                    :reduce="(doctor) => doctor"
                    :close-on-select="false"
                    @input="formatForQuery"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div
            v-if="addForm.type === 'IN' && treatment_type === 'Surgery'"
            class="mt-2 mt-md-0 w-100 mx-1"
          >
            <b-row>
              <b-col md="12" cols="12" class="mt-3">
                <b-form-group label="Doctors">
                  <v-select
                    v-model="selectedDoctors"
                    :options="doctors"
                    multiple
                    label="name"
                    :reduce="(doctor) => doctor"
                    :close-on-select="false"
                    @input="formatForQuery"
                  >
                    <template #option="{ name, type }">
                      <b style="margin: 0">
                        {{ name }}
                        <span v-if="type == 'surgeon'" class="text-primary">
                          ({{ $t("hospital.surgeon") }})
                        </span>
                        <span v-if="type == 'anesthetist'" class="text-primary">
                          ({{ $t("hospital.anesthetist") }})
                        </span>
                      </b>
                    </template>
                    <template #selected-option="{ name, type }">
                      <b style="margin: 0">
                        {{ name }}
                        <span v-if="type == 'surgeon'" class="text-success">
                          ({{ $t("hospital.surgeon") }})
                        </span>
                        <span v-if="type == 'anesthetist'" class="text-success">
                          ({{ $t("hospital.anesthetist") }})
                        </span>
                      </b>
                    </template></v-select
                  >
                </b-form-group>
              </b-col>

              <b-col md="12" cols="12" class="mb-1">
                <div class="my-1">
                  <p class="mb-0">
                    {{ $t("reception.available-surgeries-for-doctors") }}
                    (<span class="text-danger font-weight-bold">{{
                      doctorsName
                    }}</span>
                    )
                  </p>
                  <v-select
                    v-model="selectedAvailableSurgeries"
                    :options="availableSurgeriesOptions"
                    :placeholder="
                      $t('reception.available-surgeries-for-doctors')
                    "
                    label="title"
                    ><template #list-footer>
                      <b-button
                        variant="success"
                        @click="showCreateSurgeryModal"
                        size="sm"
                        block
                      >
                        {{ $t("reception.create-surgery") }}
                      </b-button>
                    </template>
                  </v-select>
                </div>
              </b-col>

              <b-modal
                id="modal-create-surgery"
                :title="$t('reception.create-surgery')"
                ok-only
                centered
                size="lg"
                :no-close-on-backdrop="true"
              >
                <div>
                  <b-form-group :label="$t('common.title')">
                    <b-form-input v-model="surgeryForm.title" />
                  </b-form-group>
                  <b-form-group :label="$t('common.description')">
                    <b-form-textarea v-model="surgeryForm.description" />
                  </b-form-group>
                  <b-form-group :label="$t('reception.type')">
                    <v-select
                      v-model="surgeryForm.type"
                      :options="surgeryTypesList"
                      label="text"
                      :reduce="(option) => option.value"
                    />
                  </b-form-group>
                </div>
                <template #modal-footer="{}">
                  <b-button
                    variant="primary"
                    @click="createSurgery"
                    class="m-0"
                    :disabled="loading"
                    ref="button"
                    block
                  >
                    <span v-if="!loading">{{ $t("common.add") }}</span>
                    <b-spinner small v-else></b-spinner>
                  </b-button>
                </template>
              </b-modal>

              <!-- <b-col class="d-flex align-items-center w-full" md="2" cols="12">
                <b-button
                  class="mx-1 w-full"
                  variant="primary"
                  size="sm"
                  @click="addDoctor"
                  >+</b-button
                >
                <b-button
                  :disabled="index === 0"
                  size="sm"
                  variant="danger"
                  @click="removeDoctor(index)"
                  >X</b-button
                >
              </b-col> -->
              <!-- <b-col md="6" cols="12">
                <b-form-group
                  :label="$t('reception.patient-case')"
                  label-for="patient_case"
                >
                  <b-form-input
                    id="patient_case"
                    v-model="addForm.patient_case"
                    :placeholder="$t('reception.patient-case')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" cols="12">
                <b-form-group
                  :label="$t('reception.diagnosis')"
                  label-for="diagnosis"
                >
                  <b-form-input
                    id="diagnosis"
                    v-model="addForm.diagnosis"
                    :placeholder="$t('reception.diagnosis')"
                  />
                </b-form-group>
              </b-col> -->
            </b-row>
          </div>
          <b-col v-if="addForm.type === 'IN'" md="12" cols="12">
            <AutoComplete
              v-model="addForm.room_id"
              class="required"
              :label="$t('reception.room')"
              :placeholder="$t('reception.room')"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="available-room"
              text-title="name"
            />
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.companion-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="addForm.full_companion_name"
                :placeholder="$t('reception.companion-name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.companion-phone')"
              label-for="phoneNumber"
            >
              <VuePhoneNumberInput
                v-model="addForm.companion_phone"
                default-country-code="IQ"
                :error="
                  addForm.companion_phone
                    ? isNotValid || addForm.companion_phone[0] != 0
                    : false
                "
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
              />
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.next-kin-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="addForm.next_of_kin_name"
                :placeholder="$t('reception.next-kin-name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('reception.next-kin-phone')"
              label-for="phoneNumber"
            >
              <VuePhoneNumberInput
                v-model="addForm.next_of_kin_phone_number"
                default-country-code="IQ"
                :error="
                  addForm.next_of_kin_phone_number
                    ? isNotValid || addForm.next_of_kin_phone_number[0] != 0
                    : false
                "
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <h3 class="text-center my-2">
              {{ $t("common.invoices") }}
            </h3>
          </b-col>
          <div
            v-for="(item, index) in invoices"
            :key="index"
            class="mt-2 mt-md-0 w-100 mx-1"
          >
            <b-row>
              <b-col md="10" cols="12" class="required">
                <ServicePriceAutoComplete
                  :label="$t('hospital.services')"
                  :placeholder="$t('hospital.services')"
                  :serializer="(val) => val"
                  param-query="search"
                  text-title="title"
                  :disable-amount="true"
                  @val="serviceValue($event, index)"
                />
              </b-col>
              <b-col class="d-flex align-items-center w-full" md="2" cols="12">
                <b-button
                  class="mx-1 w-full"
                  variant="primary"
                  size="sm"
                  @click="addInvoice"
                  >+</b-button
                >
                <b-button
                  :disabled="index === 0"
                  size="sm"
                  variant="danger"
                  @click="removeInvoice(index)"
                  >X</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-row>
      <!-- Add Button -->

      <b-col
        cols="12"
        md="12"
        class="mt-2 d-flex align-items-center justify-content-end mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="patientId ? updatePatient() : registerPatient()"
        >
          {{ patientId ? $t("common.update") : $t("common.submit") }}
        </b-button>
      </b-col>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BFormCheckbox,
  BImg,
  BModal,
  BFormRadioGroup,
  BFormRadio,
} from "bootstrap-vue";
import vSelect from "vue-select";
import VueHtml2pdf from "vue-html2pdf";
import Datepicker from "vuejs-datepicker";
import Logo from "@/assets/images/logo/waziria-logo.png";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const ServicePriceAutoComplete = () =>
  import("@/components/common/ServicePriceAutoComplete.vue");

export default {
  components: {
    BCard,
    BFormCheckbox,
    BRow,
    BCol,
    BImg,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
    Datepicker,
    AutoComplete,
    VuePhoneNumberInput,
    ServicePriceAutoComplete,
    BModal,
    BFormRadioGroup,
    BFormRadio,
  },

  data() {
    return {
      addForm: {
        name: "",
        mother_name: "",
        phone: "",
        birth_date: "",
        marital_status: "",
        education_level: "",
        residence_type: "",
        governorate_id: "",
        judiciary: "",
        town_name: "",
        city_name: "",
        district_name: "",
        street_name: "",
        building_number: "",

        document_page_number: "",
        document_number: "",
        department_of_civil_status: "",
        national_id: "",
        type: "",
        room_id: "",
        occupation: "",
        next_of_kin_phone_number: "",
        next_of_kin_name: "",
        companion_phone: "",
        full_companion_name: "",
        gender: "",
        service_id: "",
        status: "pending",
        amount: 0,
      },
      errorForm: {
        name: "",
        mother_name: "",
        phone: "",
        birth_date: "",
        marital_status: "",
        education_level: "",
        residence_type: "",
        governorate_id: "",
        next_of_kin_phone_number: "",
        next_of_kin_name: "",
        companion_phone: "",
        full_companion_name: "",
        judiciary_name: "",
        town_name: "",
        city_name: "",
        district_name: "",
        street_name: "",
        building_number: "",

        document_page_number: "",
        document_number: "",
        department_of_civil_status: "",
        national_id: "",
        type: "",
        room_id: "",
        doctor_id: "",
        occupation: "",
        gender: "",
        service_id: "",
        status: "pending",
        amount: 0,
      },
      genderOption: ["Male", "Female"],
      maritalStatusOptions: ["single", "married", "divorced", "widowed"],
      educationalLevelOptions: [
        "elementary-school",
        "middle-school",
        "high-school",
        "bachelor",
        "master",
        "phd",
        "illiterate",
        "can-read-and-write",
      ],
      residenceOptions: ["city", "countryside"],
      invoices: [
        {
          service_id: "",
          amount: 0,
        },
      ],
      hospitalLogo: Logo,
      isNotValid: false,

      params: {
        form: {},
        path: "",
      },
      surgeryTypesList: [
        {
          text: "كبرى ",
          value: "1",
        },
        {
          text: "صغرى ",
          value: "2",
        },
        {
          text: "متوسطة",
          value: "3",
        },
        {
          text: "فوق الكبرى",
          value: "4",
        },
        {
          text: "خاصة",
          value: "5",
        },
      ],
      patientId: this.$route.params.id,
      doctorsId: null,
      availableSurgeries: [],
      availableSurgeriesOptions: [],
      selectedAvailableSurgeries: "",
      doctorsName: "",
      surgeryForm: {
        title: "",
        description: "",
        type: 0,
        price: 0,
      },
      paramsForDoctorSurgery: {
        form: {
          doctor_id: "",
          surgery_id: "",
          price: 0,
        },
        path: "/doctorSurgery",
      },
      paramsForSurgery: {
        form: {
          title: "",
          description: "",
          type: 0,
          price: 0,
        },
        path: "/surgery",
      },
      loading: false,
      dateWithTime: new Date().toISOString().slice(0, 16).replace("T", " "),
      treatment_type: "",
      selectedDoctors: [],
      doctors: [],
    };
  },
  mounted() {
    this.getDoctors();
    console.log("dateWithTime", this.dateWithTime);
    this.patientId = this.$route.params.id;
    if (this.patientId) {
      this.getPatient();
    }
  },

  methods: {
    async getDoctors() {
      await this.getList("doctor?take=100").then((response) => {
        this.doctors = response.data.data.map((doctor) => ({
          id: doctor.id,
          name: doctor.name,
          type: doctor.type,
        }));
      });
    },
    // async formatForQuery(val) {
    //   this.doctorsName = this.getDoctorsName(val);
    //   this.availableSurgeriesOptions = [];
    //   this.availableSurgeries = [];
    //   let temp = ``;
    //   val.forEach((item) => {
    //     temp += `doctors[]=${item.id}&`;
    //   });
    //   this.doctorsId = temp;
    //   console.log("doctorsId", this.doctorsId);
    //   await this.getList(
    //     `surgery/availableSurgeriesForDoctors?${this.doctorsId}`     // show only available surgeries for the selected doctors
    //   );
    //   this.availableSurgeries = this.all_data;
    //   this.availableSurgeries.forEach((item) => {
    //     this.availableSurgeriesOptions.push({
    //       id: item.id,
    //       title: item.title,
    //     });
    //   });
    //   console.log("availableSurgeries", this.availableSurgeries);
    // },
    async formatForQuery(val) {
      this.doctorsName = this.getDoctorsName(val);
      this.availableSurgeriesOptions = [];
      let temp = ``;
      val.forEach((item) => {
        temp += `doctors[]=${item.id}&`;
      });
      this.doctorsId = temp;
      console.log("doctorsId", this.doctorsId);
      await this.getList(`surgery?sort=-id&take=1000`);
      this.availableSurgeries = this.all_data.data;
      this.availableSurgeries.forEach((item) => {
        this.availableSurgeriesOptions.push({
          id: item.id,
          title: item.title,
        });
      });
      console.log("availableSurgeries", this.availableSurgeries);
    },
    getDoctorsName(doctors) {
      let temp = "";
      doctors.forEach((item) => {
        temp += item.name + ", ";
      });
      return temp;
    },
    showCreateSurgeryModal() {
      this.$bvModal.show("modal-create-surgery");
    },
    async createSurgery() {
      this.loading = true;
      try {
        this.paramsForSurgery.form = this.surgeryForm;
        this.paramsForSurgery.path = "/surgery";
        this.$store
          .dispatch("create", this.paramsForSurgery)
          .then(async (surgeryResponse) => {
            console.log("surgeryResponse", surgeryResponse);
            // Link doctors to the created surgery
            const doctorSurgeryPromises = this.selectedDoctors.map((doctor) => {
              this.paramsForDoctorSurgery.form = {
                doctor_id: doctor.id,
                surgery_id: surgeryResponse.data.data.id,
                price: 0,
              };
              this.paramsForDoctorSurgery.path = "/doctorSurgery";
              return this.$store.dispatch(
                "create",
                this.paramsForDoctorSurgery
              );
            });

            await Promise.all(doctorSurgeryPromises);
            this.loading = false;
            this.$bvModal.hide("modal-create-surgery");
            await this.formatForQuery(this.selectedDoctors);
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Success",
                variant: "success",
                text: this.$t(
                  "reception.surgery-created-and-linked-to-doctors-successfully"
                ),
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                variant: "danger",
                text:
                  error.response?.data?.message ||
                  this.$t(
                    "reception.surgery-created-and-linked-to-doctors-error"
                  ),
              },
            });
          });
      } catch (error) {
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text:
              error.response?.data?.message ||
              this.$t("reception.surgery-created-and-linked-to-doctors-error"),
          },
        });
      }
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },

    addInvoice() {
      this.invoices.push({
        service_id: "",
        status: "",
        amount: 0,
      });
    },
    // addDoctor() {
    //   this.doctors.push("");
    // },

    removeInvoice(index) {
      if (index === 0) return;
      this.invoices.splice(index, 1);
    },
    // removeDoctor(index) {
    //   if (index === 0) return;
    //   this.doctors.splice(index, 1);
    // },

    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    serviceValue(service, index) {
      this.currentInvoice = {
        service_id: service.id,
        status: "pending",
        amount: service.price,
      };
      this.invoices[index] = this.currentInvoice;
    },
    // doctorValue(doctor, index) {
    //   this.currentDoctor = doctor;
    //   this.doctors[index] = this.currentDoctor;
    // },
    async getPatient() {
      await this.getList(`patient/${this.patientId}`);
      console.log(this.all_data);
      this.addForm = {
        ...this.all_data,
      };
      console.log(this.addForm);
    },

    updatePatient() {
      for (const item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.addForm[item] == "" || this.addForm[item] == null)
          delete this.addForm[item];
      }
      this.addForm.birth_date = this.formatDate(this.addForm.birth_date);

      this.addForm._method = "PUT";
      console.log(this.addForm);
      if (!this.formValid()) return;

      (this.params.form = this.addForm),
        (this.params.path = `patient/${this.patientId}`),
        this.$store
          .dispatch("update", this.params)
          .then(async (response) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Updated",
                variant: "success",
              },
            });

            this.$router.push({
              name: "Reception-Departments",
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach((item) => {
                this.errorForm[item] = error.response.data[item][0];
              });
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },

    async createPatientSurgery(response) {
      try {
        const now = new Date();
        const surgeryDateTime =
          now.getFullYear() +
          "-" +
          String(now.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(now.getDate()).padStart(2, "0") +
          " " +
          String(now.getHours()).padStart(2, "0") +
          ":" +
          String(now.getMinutes()).padStart(2, "0");

        const surgeryPayload = {
          patient_card_id: response.data.card.data.id,
          surgery_id: this.selectedAvailableSurgeries.id,
          surgery_date_time: surgeryDateTime,
          doctors: this.selectedDoctors.map((doctor) => {
            return {
              id: doctor.id,
              type: doctor.type,
            };
          }),
        };

        await this.$store.dispatch("create", {
          form: surgeryPayload,
          path: "patient-surgery",
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Surgery Scheduled",
            variant: "success",
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Surgery Creation Error",
            variant: "danger",
            text:
              error.response?.data?.message ||
              this.$t("reception.surgery-creation-error"),
          },
        });
        throw error; // Re-throw error if you need to handle it in the caller
      }
    },

    async createPatientBedRest(response) {
      try {
        const now = new Date();
        const stayDateTime =
          now.getFullYear() +
          "-" +
          String(now.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(now.getDate()).padStart(2, "0") +
          " " +
          String(now.getHours()).padStart(2, "0") +
          ":" +
          String(now.getMinutes()).padStart(2, "0");

        const bedRestPayload = {
          patient_card_id: response.data.card.data.id, // Assuming you have patient card data
          stay_date_time: stayDateTime,
          doctors: this.selectedDoctors.map((doctor) => doctor.id), // Assuming you have doctors array
        };

        await this.$store.dispatch("create", {
          form: bedRestPayload,
          path: "patient-stay",
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Bed Rest Created",
            variant: "success",
            text: "Patient bed rest has been created successfully",
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: "Failed to create bed rest",
          },
        });
        console.error("Error creating bed rest:", error);
      }
    },

    registerPatient() {
      for (const item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.addForm[item] == "" || this.addForm[item] == null)
          delete this.addForm[item];
      }

      this.addForm.invoices = this.invoices;
      this.addForm.doctors = [
        ...this.selectedDoctors.map((doctor) => doctor.id),
      ];
      this.addForm.birth_date = this.formatDate(this.addForm.birth_date);
      if (this.addForm.type !== "IN") {
        delete this.addForm.doctor_id;
        delete this.addForm.room_id;
      }
      // if (!this.formValid()) return;
      console.log("addForm", this.addForm);
      // return 0;
      (this.params.form = this.addForm),
        (this.params.path = "patientWithCard"),
        this.$store
          .dispatch("create", this.params)
          .then(async (response) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Created",
                variant: "success",
              },
            });
            console.log("response", response);
            if (
              this.treatment_type === "Surgery" &&
              this.selectedAvailableSurgeries
            ) {
              await this.createPatientSurgery(response);
            }
            if (this.treatment_type === "Bed Rest") {
              await this.createPatientBedRest(response);
            }

            this.$router.push({
              name: "Reception-Departments",
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach((item) => {
                this.errorForm[item] = error.response.data[item][0];
              });
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    formValid() {
      const requiredFields = {
        name: "The name field is required.",
        gender: "The gender field is required.",
        birth_date: [
          "The birth date field must be a valid date.",
          "The birth date field must match the format Y-m-d.",
        ],
        phone: "The phone field is required.",
        governorate_id: "The governorate id field is required.",
        city_name: "The city name field is required.",
        type: "The type field is required.",
      };

      if (this.patientId) {
        delete requiredFields.type;
      }

      let isValid = true;

      for (const field in requiredFields) {
        if (!this.addForm[field] || this.addForm[field] === "") {
          this.errorForm[field] = Array.isArray(requiredFields[field])
            ? requiredFields[field][0]
            : requiredFields[field];
          isValid = false;
        } else {
          this.errorForm[field] = "";
        }
      }

      // Additional check for birth_date format
      if (
        this.addForm.birth_date &&
        !/^\d{4}-\d{2}-\d{2}$/.test(this.addForm.birth_date)
      ) {
        this.errorForm.birth_date = requiredFields.birth_date[1];
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>
<style scoped>
.text {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 0.5fr 1.5fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "arabic-name arabic-name arabic-name"
    "arabic-name arabic-name arabic-name"
    "english-name english-name english-name"
    "logo logo logo";
  grid-area: text;
}
.logo {
  grid-area: logo;
  margin: auto;
}
.arabic-name {
  font-family: "Arabic Typesetting", "Tahoma", "Times New Roman", "Arial", serif;
  grid-area: arabic-name;
  font-size: xxx-large;
  font-weight: 900;
  color: #070050;
  margin: auto;
}

.english-name {
  font-family: "Arabic Typesetting", "Tahoma", "Times New Roman", "Arial", serif;
  grid-area: english-name;
  font-size: xxx-large;
  font-weight: 900;
  margin: auto;
  color: #070050;
}
.error {
  color: rgb(255, 0, 0) !important;
}
.required::before {
  content: " *";
  color: red;
  font-weight: bold;
  position: absolute;
  top: -10px;
}

/* Container styling */
.insurance-container {
  font-family: "Arial", sans-serif;
  max-width: 500px;
  margin: 2rem auto;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
}

/* Radio button container */
.radio-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  width: 100%;
}

/* Custom radio button styling */
.radio-input {
  display: none;
}

.radio-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  color: #34495e;
  transition: all 0.3s ease;
  padding: 0.8rem 0.5rem;
  border-radius: 8px;
  background-color: white;
  border: 2px solid #e0e0e0;
  position: relative;
}

.radio-label:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
}

/* Custom radio circle */
.radio-label::before {
  content: "";
  width: 20px;
  height: 20px;
  border: 2px solid #95a5a6;
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* Selected state styling */
.radio-input:checked + .radio-label {
  border-color: #2ecc71;
  background-color: #f0fdf4;
}

.radio-input:checked + .radio-label::before {
  border-color: #2ecc71;
  background-color: #2ecc71;
  box-shadow: inset 0 0 0 4px white;
}

/* Focus state */
.radio-input:focus + .radio-label {
  outline: 2px solid #3498db;
  outline-offset: 2px;
} /* Radio button container */
.radio-group {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

/* Custom radio button styling */
.radio-input {
  display: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  color: #34495e;
  transition: all 0.3s ease;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  background-color: white;
  border: 2px solid #e0e0e0;
  width: 100%;
  box-sizing: border-box;
}

.radio-label:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
}

/* Custom radio circle (left-aligned) */
.radio-label::before {
  content: "";
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #95a5a6;
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* Selected state styling */
.radio-input:checked + .radio-label {
  border-color: #2ecc71;
  background-color: #f0fdf4;
}

.radio-input:checked + .radio-label::before {
  border-color: #2ecc71;
  background-color: #2ecc71;
  box-shadow: inset 0 0 0 4px white;
}

/* Focus state */
.radio-input:focus + .radio-label {
  outline: 2px solid #3498db;
  outline-offset: 2px;
}

/* Text styling */
.radio-text {
  flex-grow: 1;
}

.doctor-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  text-align: center;
}

.role-selection {
  margin-top: 10px;
}

.role-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-checkbox >>> .custom-control-label {
  font-size: 14px;
  color: #333;
}

.role-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.role-checkbox >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
